/*
 * One entry per navbar link. GenericPage renders each entry by its `kind`:
 *   table – date filter + table        (GET  /api/pages/<slug>?from=&to=)
 *   tool  – search/scan box + table    (GET  /api/pages/<slug>?q=)
 *   form  – input form                 (POST /api/pages/<slug>)
 *
 * The API returns { rows: [[...], ...] } with values in the same order as `columns`.
 * To give a page its own custom screen, build a component and register it in registry.js.
 */


export const PAGES = {
  /* ───────── Sales ───────── */
  pos: {
    kind: "tool", purpose: "Ring up a sale by scanning or searching for products.",
    search: "Scan a barcode or type a product name",
    columns: ["Item", "Qty", "Unit price", "Total"],
  },
  end_of_day: { kind: "custom", purpose: "Count the till and close today's trading." }, // sales/EndOfDay.jsx
  warehousePos: { kind: "custom", purpose: "Sell warehouse inventory items." },
  adjust_stock: { kind: "custom", purpose: "Update quantities, retail and wholesale prices in bulk." },
  productAdd: { kind: "custom", purpose: "Add a new product to the catalogue." },
  assets: { kind: "custom", purpose: "Fixed assets register." },
  asset_register: { kind: "custom", purpose: "Register a new fixed asset." },
  account_form: { kind: "custom", purpose: "Add an account to the chart of accounts." },
  Approvedpo_list: { kind: "custom", purpose: "Approved purchase orders." },
  addStockreplenish: { kind: "custom", purpose: "History of stock added from suppliers." },
  stockReprenish: { kind: "custom", purpose: "Add stock received from a supplier." },
  purchase_order: { kind: "custom", purpose: "Create a purchase order for a supplier." },
  addStock: { kind: "custom", purpose: "All products with prices, stock and expiry dates." },
  AddPayment: { kind: "custom", purpose: "All products with prices, stock and expiry dates." },
  stockMgt: { kind: "custom", purpose: "Manage and monitor stock-related activities." },
  stockexpiry: { kind: "custom", purpose: "Products expiring within the next 30 days." },
  stockanalytics: { kind: "custom", purpose: "Stock on hand as a percentage of minimum stock." },
  stockAnalysis: { kind: "custom", purpose: "Totals, stock by product type, and products below minimum." },
  select_statement: { kind: "custom", purpose: "Running statement for an account between two dates." },
  saledates: { kind: "custom", purpose: "Daily trend, top products and unusual transactions." },
  "sales-report": { kind: "custom", purpose: "Compare the sales of two products." },
  sales_analysis: { kind: "custom", purpose: "One day of sales at a glance." },
  receive_payment: { kind: "custom", purpose: "Receive a payment against a client's outstanding invoices." },
  ReceiveCash: { kind: "custom", purpose: "Record service, prepayment and capital receipts, then verify them." },
  "run-payroll": { kind: "custom", purpose: "Post pending payroll payments to the ledger." },
  revenuetransaction: { kind: "custom", purpose: "Revenue transaction screens." },
  payableList: { kind: "custom", purpose: "Goods received that are not yet fully paid." },
  addEmployee: { kind: "custom", purpose: "Staff, their roles, next of kin and education." },
  payroll: { kind: "custom", purpose: "Generate, verify, authorise and post payroll, and view payslips." },
  PayrolManagement: { kind: "custom", purpose: "Create this month's payroll for active staff." },
  leaveList: { kind: "custom", purpose: "Leave requests and their status." },
  callGrn: { kind: "custom", purpose: "Goods received notes." },
  "payroll-run-view": { kind: "custom", purpose: "Pending payroll payments, and posting them to the ledger." },
  end_of_day_details: { kind: "custom", purpose: "One End of Day closing in full." },
  po_list: { kind: "custom", purpose: "All purchase orders." },
  grn: { kind: "custom", purpose: "Receive goods against an approved purchase order." },
  grn_list: { kind: "custom", purpose: "Goods received notes." },
  GRNcall: { kind: "custom", purpose: "Goods received notes." },
  equitytransaction: { kind: "custom", purpose: "Fixed assets and capital." },
  expensetransaction: { kind: "custom", purpose: "Payroll and depreciation." },
  callBalancesheet: { kind: "custom", purpose: "Assets, liabilities and equity as at a date." },
  balanceSheet: { kind: "custom", purpose: "Assets, liabilities and equity as at a date." },
  income_statement: { kind: "custom", purpose: "Revenue, cost of sales, expenses and net income for a period." },
  callFinance: { kind: "custom", purpose: "Revenue, cost of sales, expenses and net income for a period." },
  invoice_payments: { kind: "custom", purpose: "Outstanding invoices by client, with SMS reminders." },
  PaymentList: { kind: "custom", purpose: "Payments for a period: totals, trend, clients and methods." },
  other_payments_form: { kind: "custom", purpose: "Record and verify payables such as rent, advances and drawings." },
  paymentAjax: { kind: "custom", purpose: "Every payment record." },
  managingcustomercredit: { kind: "custom", purpose: "Customer invoicing and credit authorization." },
  invoice_approval: { kind: "custom", purpose: "Review pending invoices: edit, reject or approve." },
  invoice_view: { kind: "custom", purpose: "One invoice and its lines." },
  invoice: { kind: "custom", purpose: "Sell on credit and raise an invoice." },
  productdates: { kind: "custom", purpose: "Revenue, profit and quantity sold by product." },
  productlist: { kind: "custom", purpose: "All products with prices, units and stock." },
  employerAdd: { kind: "custom", purpose: "Register a staff member as an employee." },
  otherStaffInfo: { kind: "custom", purpose: "An employee's education and next of kin." },
  LeaveRequest: { kind: "custom", purpose: "Request leave for a staff member." },
  make_grn_payment: { kind: "custom", purpose: "Pay a supplier for goods received." },
  update_asset: { kind: "custom", purpose: "Edit or delete a fixed asset." },
  "user-management": { kind: "custom", purpose: "Create user accounts, change roles and activate or deactivate users." },
  my_hr: { kind: "custom", purpose: "Your payslips, leave history and leave requests." },
  end_of_day_history: { kind: "custom", purpose: "Past day closings and any cash differences." },
  sales_day: { kind: "custom", purpose: "Sales for a period compared with the period before." },
  sales: { kind: "custom", purpose: "Revenue, profit, top products and every sale for a period." },
  salesExtend: { kind: "custom", purpose: "Sales and profit month by month." },
  saleIndividual: { kind: "custom", purpose: "Sales history of a single product." },

  /* ───────── Inventory ───────── */
  update_barcode: { kind: "custom", purpose: "Assign barcodes to products and fix wrong ones." },
  productedit: { kind: "custom", purpose: "Edit product details, prices and stock." },
  wholesale_pos: { kind: "custom", purpose: "Sell mixed crates at wholesale prices." },
  wholesale_prices: { kind: "custom", purpose: "Set per-product, per-package prices for wholesale sales." },
  stockrecon: { kind: "custom", purpose: "Count stock and record differences against the system quantity." },
  stockrecon_report: { kind: "custom", purpose: "Stock reconciliation activity and variance value for a date range." },
  purchasing: { kind: "custom", purpose: "Build a purchase list and record it when the deal is done." },
  expiry_dashboard: { kind: "custom", purpose: "Stock by expiry status, value at risk, and expiry dates." },
  availabilty: { kind: "custom", purpose: "Top products by sales, profit and stock level, with side-by-side comparison." },
  report_zero_stock: { kind: "custom", purpose: "Products with no stock left." },
  purchase_history: { kind: "custom", purpose: "Completed purchase batches." },
  stockStatus: { kind: "custom", purpose: "Stock value and products without a barcode." },
  productprint: { kind: "custom", purpose: "A printable sheet for physical stock counts." },

  /* ───────── Finance ───────── */
  "verify-payment": { kind: "custom", purpose: "Review and verify pending POS, store and service payments." },
  assetTransaction: { kind: "custom", purpose: "Operations related to assets and inventory." },
  liabilityTransaction: { kind: "custom", purpose: "Purchase orders, goods received and vendor payments." },
  ext_fund: { kind: "custom", purpose: "Money customers paid in advance, and refunds." },
  accountBalance: { kind: "custom", purpose: "Every active account with its balance." },
  accountBalanceL: { kind: "custom", purpose: "Individual ledger entries with filters and CSV export." },
  trial_balance: { kind: "custom", purpose: "Debit and credit balances for every active account." },
  journal_entry: { kind: "custom", purpose: "Post a balanced manual journal entry." },
  accountStatement: { kind: "custom", purpose: "Running statement for an account between two dates." },
  financialReports: { kind: "custom", purpose: "Financial statements and reports." },
  cashflow: { kind: "custom", purpose: "Cash and bank movements, trend and details." },
  reportAnalytics: { kind: "custom", purpose: "Sales and stock analytics." },
  service_payments_report: { kind: "custom", purpose: "Service payments by date, client, method and service." },
  mobile_money_float: { kind: "custom", purpose: "Register and manage MNO lines and their float." },
  mobile_money_report: { kind: "custom", purpose: "Commission by operator and by day." },

  /* ───────── Customers ───────── */
  client: { kind: "custom", purpose: "Clients and their contact details." },
  ServiceList: { kind: "custom", purpose: "Services you offer, and selling them." },
  mobile_money: { kind: "custom", purpose: "Record a mobile money cash in or cash out." },
  mobile_money_history: { kind: "custom", purpose: "All recorded mobile money transactions." },
  clientSms: { kind: "custom", purpose: "Send an SMS to every client." },
  invoiceCall: { kind: "custom", purpose: "Choose an invoice to print." },
  poCall: { kind: "custom", purpose: "Choose a purchase order to print." },
  "grn-report": { kind: "custom", purpose: "Goods received notes." },
  GRNreceipts: { kind: "custom", purpose: "POS payments and their receipts." },

  /* ───────── Account & administration ───────── */
  profile: { kind: "custom", purpose: "Your account details and password." },
  refill: { kind: "custom", purpose: "Stock replenishments with filters and CSV export." },
  HrMng: { kind: "custom", purpose: "Employees, payroll and leave." },
  active_sessions: { kind: "custom", purpose: "Who is signed in right now. Admins can end a session." },
  logs: { kind: "custom", purpose: "A record of actions taken in the system." },
};
